import styled, { css } from 'styled-components';
import BottomBar from '../bottom-bar';
import Header from './Header';

const PageMobileStyled = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    ${({ $useScroll }) =>
        !$useScroll &&
        css`
            height: 100vh;
            overflow: hidden;
        `}
`;

const HeaderSpacer = styled.div`
    height: calc(58px + env(safe-area-inset-top));
`;

const CustomBottomBarWrapper = styled.div`
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    min-height: 64px;
    > * {
        padding-bottom: env(safe-area-inset-bottom);
    }
`;

/**
 * A mobile page layout component with a header, body container, and bottom bar.
 *
 * @component
 * @param {object} props - The component props.
 * @param {React.ReactNode} props.children - The main content to be rendered in the page body.
 * @param {React.ReactNode} [props.customBottomBar] - Optional custom bottom bar to replace the default one.
 * @param {boolean} [props.containerBody=true] - Whether to add padding around the body content.
 * @param {boolean} [props.showHeader=true] - Whether to display the header at the top of the page.
 * @param {React.ReactNode} [props.customHeader] - Optional custom header component to replace the default one.
 * @param {boolean} [props.usebBackgroundColor=true] - Whether to apply a background color (`#F3FBFA`) to the body section.
 * @param {boolean} [props.showBack]
 * @param {Function} [props.onBack] - Optional custom handler for back button.
 * @param {import('react').ReactNode} [props.extraButton]
 * @param {string} [props.titleHeader]
 * @param {object} [props.style]
 * @returns {JSX.Element} The mobile page layout component.
 */
function PageMobile({
    children,
    customBottomBar,
    containerBody = true,
    showHeader = true,
    customHeader,
    usebBackgroundColor = true,
    showBack,
    onBack,
    extraButton,
    titleHeader,
    isUseScroll = true,
    style,
    styleBottomBar
}) {
    return (
        <PageMobileStyled $useScroll={isUseScroll}>
            {showHeader && (
                <Header showBack={showBack} customHeader={customHeader} extraButton={extraButton} titleHeader={titleHeader} onBack={onBack} />
            )}

            {!customHeader && showHeader && <HeaderSpacer />}
            <section
                style={{
                    padding: containerBody ? 16 : 0,
                    position: 'relative',
                    ...(!usebBackgroundColor && { background: '#fff' }),
                    ...(!isUseScroll && { flex: 1, overflow: 'hidden', minHeight: 0 }),
                    ...style,
                }}
            >
                {children}
            </section>

            {customBottomBar ? <CustomBottomBarWrapper style={{ ...styleBottomBar }}>{customBottomBar}</CustomBottomBarWrapper> : customBottomBar !== null && <BottomBar />}
        </PageMobileStyled>
    );
}

export default PageMobile;
